interface PeopleInsideGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleInsideGearSVG = ({ color, style }: PeopleInsideGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46514)">
      <path
        d="M50.9168 28.1666V23.8333H47.5585C47.3202 21.45 46.681 19.1966 45.7385 17.1058L48.6635 15.4158L46.4968 11.6675L43.5718 13.3575C42.2068 11.4616 40.5385 9.80415 38.6535 8.43915L40.3435 5.51415L36.5952 3.34748L34.9052 6.27248C32.8143 5.32998 30.561 4.69081 28.1777 4.45248V1.08331H23.8443V4.44165C21.461 4.67998 19.2077 5.31915 17.1168 6.26165L15.4268 3.33665L11.6785 5.50331L13.3685 8.42831C11.4727 9.79331 9.81516 11.4616 8.45016 13.3466L5.52516 11.6566L3.3585 15.405L6.2835 17.095C5.341 19.1858 4.70183 21.4391 4.4635 23.8225H1.0835V28.1558H4.44183C4.68016 30.5391 5.31933 32.7925 6.26183 34.8833L3.33683 36.5733L5.5035 40.3216L8.4285 38.6316C9.7935 40.5275 11.4618 42.185 13.3468 43.55L11.6568 46.475L15.4052 48.6416L17.0952 45.7166C19.186 46.6591 21.4393 47.2983 23.8227 47.5366V50.895H28.156V47.5366C30.5393 47.2983 32.7927 46.6591 34.8835 45.7166L36.5735 48.6416L40.3218 46.475L38.6318 43.55C40.5277 42.185 42.1852 40.5166 43.5502 38.6316L46.4752 40.3216L48.6418 36.5733L45.7168 34.8833C46.6593 32.7925 47.2985 30.5391 47.5368 28.1558H50.8952L50.9168 28.1666Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.9998 43.3334C35.5728 43.3334 43.3332 35.573 43.3332 26C43.3332 16.4271 35.5728 8.66669 25.9998 8.66669C16.4269 8.66669 8.6665 16.4271 8.6665 26C8.6665 35.573 16.4269 43.3334 25.9998 43.3334Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M30 19.7143C30 22.0857 28.2133 24 26 24C23.7867 24 22 22.0857 22 19.7143V18.2857C22 15.9143 23.7867 14 26 14C28.2133 14 30 15.9143 30 18.2857V19.7143Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18 36V33.2C18 30.876 19.7867 29 22 29H30C32.2133 29 34 30.876 34 33.2V36"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46514">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PeopleInsideGearSVG;
